import moment from 'moment';

export class DirectoryEntryHelper {
   public static createNewDirectoryEntry(id: number) {
      return {
         id: id,
         orgnum: '',
         orgnam: '',
         orgcreate: { value: moment(moment.now()).toDate(), isPrivate: false, isValueSet: false },
         orgupdate: { value: moment(moment.now()).toDate(), isPrivate: false, isValueSet: false },
         usrnam: '',
         email: { value: '', isPrivate: false, isValueSet: false },
         dnaId: { value: 0, isPrivate: false, isValueSet: false },
         org00: { value: 0, isPrivate: false, isValueSet: false },
         org01: { value: 0, isPrivate: false, isValueSet: false },
         org02: { value: 0, isPrivate: false, isValueSet: false },
         org03: { value: 0, isPrivate: false, isValueSet: false },
         org04: { value: 0, isPrivate: false, isValueSet: false },
         org05: { value: 0, isPrivate: false, isValueSet: false },
         org06: { value: 0, isPrivate: false, isValueSet: false },
         org07: { value: 0, isPrivate: false, isValueSet: false },
         org08: { value: 0, isPrivate: false, isValueSet: false },
         org09: { value: 0, isPrivate: false, isValueSet: false },
         org10: { value: 0, isPrivate: false, isValueSet: false },
         org11: { value: 0, isPrivate: false, isValueSet: false },
         org12: { value: 0, isPrivate: false, isValueSet: false },
         org13: { value: 0, isPrivate: false, isValueSet: false },
         org14: { value: 0, isPrivate: false, isValueSet: false },
         org15: { value: 0, isPrivate: false, isValueSet: false },
         org16: { value: 0, isPrivate: false, isValueSet: false },
         org17: { value: 0, isPrivate: false, isValueSet: false },
         org18: { value: 0, isPrivate: false, isValueSet: false },
         org19: { value: 0, isPrivate: false, isValueSet: false },
         org20: { value: 0, isPrivate: false, isValueSet: false },
         field00: { value: '', isPrivate: false, isValueSet: false },
         field01: { value: '', isPrivate: false, isValueSet: false },
         field02: { value: '', isPrivate: false, isValueSet: false },
         field03: { value: '', isPrivate: false, isValueSet: false },
         field04: { value: '', isPrivate: false, isValueSet: false },
         field05: { value: '', isPrivate: false, isValueSet: false },
         field06: { value: '', isPrivate: false, isValueSet: false },
         field07: { value: '', isPrivate: false, isValueSet: false },
         field08: { value: '', isPrivate: false, isValueSet: false },
         field09: { value: '', isPrivate: false, isValueSet: false },
         field10: { value: '', isPrivate: false, isValueSet: false },
         field11: { value: '', isPrivate: false, isValueSet: false },
         field12: { value: '', isPrivate: false, isValueSet: false },
         field13: { value: '', isPrivate: false, isValueSet: false },
         field14: { value: '', isPrivate: false, isValueSet: false },
         field15: { value: '', isPrivate: false, isValueSet: false },
         field16: { value: '', isPrivate: false, isValueSet: false },
         field17: { value: '', isPrivate: false, isValueSet: false },
         field18: { value: '', isPrivate: false, isValueSet: false },
         field19: { value: '', isPrivate: false, isValueSet: false },
         field20: { value: '', isPrivate: false, isValueSet: false },
         field21: { value: '', isPrivate: false, isValueSet: false },
         field22: { value: '', isPrivate: false, isValueSet: false },
         field23: { value: '', isPrivate: false, isValueSet: false },
         field24: { value: '', isPrivate: false, isValueSet: false },
         field25: { value: '', isPrivate: false, isValueSet: false },
         field26: { value: '', isPrivate: false, isValueSet: false },
         field27: { value: '', isPrivate: false, isValueSet: false },
         field28: { value: '', isPrivate: false, isValueSet: false },
         field29: { value: '', isPrivate: false, isValueSet: false },
         field30: { value: '', isPrivate: false, isValueSet: false },
         field31: { value: '', isPrivate: false, isValueSet: false },
         field32: { value: '', isPrivate: false, isValueSet: false },
         field33: { value: '', isPrivate: false, isValueSet: false },
         field34: { value: '', isPrivate: false, isValueSet: false },
         field35: { value: '', isPrivate: false, isValueSet: false },
         field36: { value: '', isPrivate: false, isValueSet: false },
         field37: { value: '', isPrivate: false, isValueSet: false },
         field38: { value: '', isPrivate: false, isValueSet: false },
         field39: { value: '', isPrivate: false, isValueSet: false },
         field40: { value: '', isPrivate: false, isValueSet: false },
         field41: { value: '', isPrivate: false, isValueSet: false },
         field42: { value: '', isPrivate: false, isValueSet: false },
         field43: { value: '', isPrivate: false, isValueSet: false },
         field44: { value: '', isPrivate: false, isValueSet: false },
         field45: { value: '', isPrivate: false, isValueSet: false },
         field46: { value: '', isPrivate: false, isValueSet: false },
         field47: { value: '', isPrivate: false, isValueSet: false },
         field48: { value: '', isPrivate: false, isValueSet: false },
         field49: { value: '', isPrivate: false, isValueSet: false },
         field50: { value: '', isPrivate: false, isValueSet: false },
         field51: { value: '', isPrivate: false, isValueSet: false },
         field52: { value: '', isPrivate: false, isValueSet: false },
         field53: { value: '', isPrivate: false, isValueSet: false },
         field54: { value: '', isPrivate: false, isValueSet: false },
         field55: { value: '', isPrivate: false, isValueSet: false },
         field56: { value: '', isPrivate: false, isValueSet: false },
         field57: { value: '', isPrivate: false, isValueSet: false },
         field58: { value: '', isPrivate: false, isValueSet: false },
         field59: { value: '', isPrivate: false, isValueSet: false },
         altnst: { value: '', isPrivate: false, isValueSet: false },
         nstmemo: { value: '', isPrivate: false, isValueSet: false },
         nstbem: { value: '', isPrivate: false, isValueSet: false },
         acshide: { value: false, isPrivate: false, isValueSet: false },
         enableSipcti: { value: false, isPrivate: false, isValueSet: false },
         dnaNodeId: { value: 0, isPrivate: false, isValueSet: false },
         userstate: { value: '', isPrivate: false, isValueSet: false },
         sms: { value: '', isPrivate: false, isValueSet: false },
         ccmext: '',
         ocsId: '',
         exchangeuser: '',
         pin: '',
         announcementType: { value: 0, isPrivate: false, isValueSet: false },
         noVoicebox: { value: false, isPrivate: false, isValueSet: false },
         calendarHost: '',
         calendarType: { value: 0, isPrivate: false, isValueSet: false },
         presenceType: { value: 0, isPrivate: false, isValueSet: false },
         nstmemo2: { value: '', isPrivate: false, isValueSet: false },
         transferTimeout: { value: 0, isPrivate: false, isValueSet: false },
         tr87Number: '',
         fldMobile: '',
      };
   }
}
